export default __webpack_public_path__ + "static/media/needed-desktop.13ae3ace.png";